import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    button: {
        borderRadius: 'var(--borderRadius)',
        color: 'var(--primary-main)',
        letterSpacing: '0.4px',
        '&.MuiButton-containedPrimary': {
            background: 'var(--primary-main)',
            borderRadius: 'var(--borderRadius) !important',
            color: 'var(--white)',
        },
    },
    portfolioDialog: {
        maxWidth: '392px',
        paddingLeft: '24px',
    },
    portfolioBtn: {
        color: 'var(--primary-main, #2196F3)',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
    },
    portfolioTitle: {
        marginLeft: '-20px',
        color: 'var(--text-primary, rgba(0, 0, 0, 0.87))',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150%',
        letterSpacing: '0.15px',
    },
    typography:{
        color: 'var(--text-primary, rgba(0, 0, 0, 0.87))',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150%',
        letterSpacing: '0.15px'
    },
    typographyBold:{
        color: 'var(--text-primary, rgba(0, 0, 0, 0.87))',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '0.15px'
    }
}))
